exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".job-wrapper[data-v-d1cd53ee]{background:#efecec}.sticky-footer .tab-pane[data-v-d1cd53ee]{padding:15px}.sticky-footer .tab-pane[data-v-d1cd53ee] .form-body{overflow-y:scroll;height:calc(var(--window-height, 100vh) - var(--sticky-header-height, 173px) + 100px)}@media (min-width:768px){.sticky-footer .tab-pane[data-v-d1cd53ee] .form-body{height:calc(var(--window-height, 100vh) - var(--sticky-header-height, 222px) + 100px)}}.job-title[data-v-d1cd53ee]{margin-top:.5rem}@media (max-width:767.98px){.job-title[data-v-d1cd53ee]{margin-top:0;font-size:1rem;font-weight:700;margin-bottom:0}}", ""]);

// exports
